<template>
  <div class="container-fluid">
    <tab></tab>
    <div class="row">
      <div id="carousel-example-generic1" class="carousel slide index-top-web" :class="{'hidden-xs hidden-sm':isShowWeb}" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic1" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in indexBanner" :key="index"></li>
        </ol>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox" >
          <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in indexBanner" :key="index">
            <img :src="item.pic_urlStr" alt="#" class="inner-item-img"/>

            <!-- <div class="inner-item-center">
              <div class="item-center-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="item-center-tips">{{lanType==1?item.sub_title:item.sub_titleEn}}</div>
            
              <div class="item-center-btn" @click="goPage(item)">{{lanType==1?'了解更多':'Learn more'}}</div>
            </div> -->
          </div>
        </div>
      </div>

      <div id="carousel-example-generic2" class="carousel slide index-top-phone hidden-md hidden-lg"  v-if="isShowWeb" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic2" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in indexBanner" :key="index"></li>
        </ol>

        <div class="carousel-inner" role="listbox">
          <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in indexBanner" :key="index">
            <img :src="item.pic_urlStr" alt="#" class="phone-inner-img"/>

            <!-- <div class="phone-inner-center">
              <div class="phone-center-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="phone-center-tips">{{lanType==1?item.sub_title:item.sub_titleEn}}</div>
            
              <div class="phone-center-btn" @click="goPage(item)">{{lanType==1?'了解更多':'Learn more'}}</div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="z-index:9;position: relative;">
      <div class="index-neck" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <!-- <div class="web-index-neck">{{lanType==1?projectBlock.title:projectBlock.titleEn}}</div> -->
        <!-- v-html="lanType==1?projectBlock.content:projectBlock.contentEn" -->
        <div class="index-neck-tips spaceBetween">
          <!-- <img src="@/images/icon3.png" alt="#" class="neck-tips-img"> -->
          <div class="neck-tips-font">
            <div class="tips-font-title">CBH助力企业气候行动</div>
            <div class="tips-font-title">为企业的可持续发展保驾护航</div>
            <div v-html="lanType==1?projectBlock.content:projectBlock.contentEn"></div>
          </div>
        </div>
      
        <div id="carousel-example-generic3" class="carousel slide index-neck-web hidden-xs hidden-sm" data-ride="carousel" style="padding:0 0.5rem;">
          <!-- <ol class="carousel-indicators index-neck-indicators">
            <li data-target="#carousel-example-generic3" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.pcData" :key="index"></li>
          </ol> -->
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox" style="overflow:inherit;">
            <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.pcData" :key="index">
              <div class="index-neck-item spaceBetween">

                <div class="neck-item-list spaceBetween">
                  <div class="item-list-li" v-for="(res,i) in item" :class="'list-li-bg'+i" :key="i" @click="goChance(res)">
                    <span>{{lanType==1?res.title:res.titleEn}}</span>
                    <!-- <div class="list-li-center" v-if="res.id==3">
                      <div class="list-btns-btn color1" v-for="(data,num) in res.titleList" :key="num" @click.stop="goChanceList(data)">{{lanType==1?data.title:data.titleEn}}</div>
                    </div> -->
                  </div>
                </div>

                <!-- <div class="columnCenter" :class="res.hover||res.titleList.length==0?'hiddenHover':'neck-item-list'" v-for="(res,i) in item" :key="i" @click="goChance(res)">
                  <img :src="res.picStr" alt="#" class="item-list-img">
                  <div class="item-list-font color1">{{lanType==1?res.title:res.titleEn}}</div>
                  <div class="item-list-btns" v-if="res.id!=4">
                    <div class="list-btns-btn color1 border1" v-for="(data,num) in res.titleList" :key="num" @click.stop="goChanceList(data)">{{lanType==1?data.title:data.titleEn}}</div>
                  </div>
                </div> -->

                
              </div>
            </div>
          </div>

          <!-- <a class="left neck-btn-left middle" href="#carousel-example-generic3" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
          </a>
          <a class="right neck-btn-right middle" href="#carousel-example-generic3" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
          </a> -->
        </div>
      </div>

      <div class="phone-neck hidden-md hidden-lg" v-if="isShowWeb">
        <!-- <div class="phone-index-neck">{{lanType==1?projectBlock.title:projectBlock.titleEn}}</div> -->
        <!-- <img src="@/images/icon3.png" alt="#" class="phone-neck-img"> -->
        <div class="phone-neck-tips" v-html="lanType==1?projectBlock.content:projectBlock.contentEn"></div>
      
        <div id="carousel-example-generic4" class="carousel slide index-neck-web" data-ride="carousel">
          <!-- <ol class="carousel-indicators phone-neck-indicators">
            <li data-target="#carousel-example-generic4" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.data" :key="index"></li>
          </ol> -->
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <div class="carousel-inner-list" v-for="(item,index) in pageProjectList.data" :key="index">
              <div class="inner-list-li" :class="'inner-li-bg'+res.id" v-for="(res,i) in item" :key="i" @click="goChance(res)" v-if="res.id!=3">
                <span>{{lanType==1?res.title:res.titleEn}}</span>
              </div>
              <div class="inner-list-li" :class="'inner-li-bg'+res.id" v-for="(res,i) in item" :key="i" @click="showLayerBtn(res)" v-if="res.id==3">
                <span>{{lanType==1?res.title:res.titleEn}}</span>
              </div>
            </div>
            <!-- <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.data" :key="index">
              <div class="phone-neck-item spaceBetween">
                <div class="phone-item-list columnCenter" v-for="(res,i) in item" :key="i" @click="goChance(res)">
                  <img :src="res.picStr" alt="#" class="phone-item-img">
                  <div class="phone-item-font color1">{{lanType==1?res.title:res.titleEn}}</div>
                  <div class="phone-item-btns">
                    <div class="phone-btns-btn color1" v-for="(data,num) in res.titleList" :key="num" @click.stop="goChanceList(data)">{{lanType==1?data.title:data.titleEn}}</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}" v-if="newsList.length>0">
        <div class="web-index-neck">{{lanType==1?'新闻动态':'News'}}</div>

        <div class="web-index-leg spaceBetween">
          <div class="index-leg-left">
            <div class="leg-left-top">
              <img :src="newsList[0].picStr" alt="#" class="leg-left-img">
              <div class="left-top-bottom" >
                <div class="top-bottom-list" v-if="newsList&&newsList.length>0&&newsList[0].title_sup">{{lanType==1?newsList[0].title_sup:newsList[0].title_supEn}}</div>
                <div class="top-bottom-list" v-if="newsList&&newsList.length>0&&newsList[0].title_sub">{{lanType==1?newsList[0].title_sub:newsList[0].title_sub}}</div>
              </div>
            </div>
            <div class="leg-left-center">
              <div class="left-center-title">{{lanType==1?newsList[0].title:newsList[0].titleEn}}</div>
              <div class="left-center-tips">{{lanType==1?newsList[0].brief:newsList[0].briefEn}}</div>
              <div class="left-center-bottom spaceBetween" @click="goMechanism(newsList[0])">
                <div class="center-bottom-left">{{newsList[0].release_date}}</div>
                <div class="center-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

          <div class="index-leg-right columnBetween">
            <div class="leg-right-list spaceBetween" v-for="(item,index) in newsList" :key="index" v-if="index>0">
              <div class="right-list-left">
                <img :src="item.picStr" alt="#" class="list-left-img">
                <div class="list-left-bottom">
                  <div class="list-left-list" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                  <div class="list-left-list bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                </div>
              </div>
              <div class="right-list-right columnBetween">
                <div class="list-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="right-list-bottom spaceBetween" @click="goMechanism(item)">
                  <div class="center-bottom-left list-bottom-left">{{item.release_date}}</div>
                  <div class="center-bottom-left color1 list-bottom-left">{{lanType==1?'查看详情':'View details'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="web-belly-btn middle" @click="goNewsList">{{lanType==1?'了解更多':'Learn More'}}</div>
      </div>

      <div class="hidden-md hidden-lg" v-if="newsList.length>0&&isShowWeb">
        <div class="phone-index-neck">{{lanType==1?'新闻动态':'News'}}</div>

        <div class="phone-index-leg">
          <div class="phone-leg-top">
            <div class="leg-top-images">
              <img :src="newsList[0].picStr" alt="#" class="top-images-img"/>
              <div class="top-images-list">
                <div class="images-list-li" v-if="newsList&&newsList.length>0&&newsList[0].title_sup">{{lanType==1?newsList[0].title_sup:newsList[0].title_supEn}}</div>
                <div class="images-list-li" v-if="newsList&&newsList.length>0&&newsList[0].title_sub">{{lanType==1?newsList[0].title_sub:newsList[0].title_subEn}}</div>
              </div>
            </div>
            <div class="leg-top-bottom">
              <div class="top-bottom-title">{{lanType==1?newsList[0].title:newsList[0].titleEn}}</div>
              <div class="top-bottom-tips">{{lanType==1?newsList[0].brief:newsList[0].briefEn}}</div>
              <div class="top-bottom-bottom spaceBetween" @click="goMechanism(newsList[0])">
                <div class="bottom-bottom-left ">{{newsList[0].updated_at}}</div>
                <div class="bottom-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

          <div class="phone-leg-list spaceBetween" v-for="(item,index) in newsList" :key="index" v-if="index>0">
            <div class="leg-list-left">
              <img :src="item.picStr" alt="#" class="list-left-img" />
              <div class="phone-list-bottom">
                <div class="images-list-li" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                <div class="images-list-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
              </div>
            </div>
            <div class="leg-list-right columnBetween">
              <div class="phone-list-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="top-bottom-bottom spaceBetween" @click="goMechanism(item)">
                <div class="bottom-bottom-left ">{{item.updated_at}}</div>
                <div class="bottom-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

        </div>

        <div class="phone-center-btn middle" @click="goNewsList" style="margin:0.5rem auto;">{{lanType==1?'了解更多':'Learn More'}}</div>
      </div>
    </div> -->

    <!-- <div class="row">
      <div class="" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-belly-center">
          <img :src="indexBg" v-show="videoPlay=='end'" alt="#" class="belly-center-img"/>
          <img src="@/images/playBtn.png" v-show="videoPlay=='start'" alt="#" class="belly-center-imgBtn"/>
          <video-player class="video-player belly-center-img vjs-custom-skin"
            v-show="videoPlay=='start'||videoPlay=='play'"
            ref="videoPlayer" 
            :playsinline="true"
            @ended="onPlayerEnded($event)"
            :options="playerOptions"
          ></video-player>
          <div class="web-belly-content" v-show="videoPlay=='end'">
            <div class="belly-content-top">
              <div class="belly-top-font" @click="toReplay">
                <img src="@/images/play.png" alt="#" class="belly-top-img"/>
                <div class="belly-top-tips">{{lanType==1?'重播视频':'Replay'}}</div>
              </div>
            </div>
            <div class="belly-content-center spaceBetween">
              <div class="content-center-list" v-for="(item,index) in indexVideos" :key="index"> 
                <div class="center-list-video" @click="choiceVideo(index)">
                  <img :src='item.picStr' alt="#" class="list-video-real" style="width:100%;"/>
                </div>
                <div class="center-list-font">{{lanType==1?item.title:item.titleEn}}</div>
              </div>
            </div>
            <div class="web-belly-btn middle" @click="goVideos">{{lanType==1?'了解更多':'Learn More'}}</div>
          </div>
        </div>
      </div>

      <div class="hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-index-neck">{{lanType==1?'视频':'Video'}}</div>

        <div id="carousel-example-generic5" class="carousel slide phone-belly-center">

          <div class="carousel-inner" role="listbox" style="height:100%;">

            <div class="swiper-slide item" :class="{'active':index=='0'}" v-for="(item,index) in indexVideos" :key="index"  @click="playVideo(index)">
              <img :src="item.picStr" v-show="videoPlay=='start'||videoPlay=='end'" alt="#" class="phone-belly-img"/>
              <img src="@/images/playBtn.png" v-show="videoPlay=='start'||videoPlay=='end'" alt="#" class="belly-center-imgBtn phone-belly-imgBtn"/>
              <video :id="'pcVideo'+index" preload="auto" :poster='item.picStr' :src="item.contentStr" controls="controls" class="phone-belly-img pcVideo">
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </div>

        </div>

        <div class="phone-center-btn middle" @click="goVideos" style="margin:0.5rem auto;">{{lanType==1?'了解更多':'Learn More'}}</div>
      </div>
    </div> -->

    <!-- <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-neck">{{lanType==1?'活动':'Events'}}</div>
        <div class="web-index-foot">
          <div class="index-foot-tips">2020年11月</div> 删除
          <div class="index-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
            <div class="foot-list-left start">
              <div class="list-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
                <div class="left-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                    <div class="bottom-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">{{lanType==1?'查看详情':'View details'}}</div>
          </div>
          <div class="index-foot-list spaceBetween" @click="goActivityDetail">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">查看详情</div>
          </div>
        </div>

        <div class="web-belly-btn middle" @click="goActivity">{{lanType==1?'了解更多':'Learn More'}}</div>
        <div class="web-index-foot">
          <div class="index-foot-tips">2020年11月</div>
          <div class="index-foot-list spaceBetween" @click="goActivityDetail">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right" @click="goActivityDetail">查看详情</div>
          </div>
          <div class="index-foot-list spaceBetween" @click="goActivityDetail">
            <div class="foot-list-left start">
              <div class="list-left-tips">SBTi</div>
              <div class="list-left-radiu border1 columnCenter">
                <div class="left-radiu-tips color1">11月</div>
                <div class="left-radiu-center color1">20日</div>
              </div>
              <div class="list-left-right">
                <div class="left-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="left-right-bottom start">
                  <div class="right-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">线上会议</div>
                  </div>
                  <div class="right-bottom-list start">
                    <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                    <div class="bottom-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="foot-list-right">查看详情</div>
          </div>
        </div>
      </div>

      <div class="hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-index-neck">{{lanType==1?'活动预告':'Events'}}</div>

        <div class="phone-index-foot">
          <div class="phone-foot-tips">2020年11月</div>
          <div class="phone-foot-list spaceBetween">
            <div class="phone-list-left start" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
              <div class="phone-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
                <div class="phone-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                    <div class="phone-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="phone-foot-list spaceBetween" @click="goActivityDetail">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="phone-center-btn middle" @click="goActivity" style="margin:0.5rem auto;">{{lanType==1?'了解更多':'Learn More'}}</div>
        <div class="phone-index-foot">
          <div class="phone-foot-tips">2020年11月</div>
          <div class="phone-foot-list spaceBetween" @click="goActivityDetail">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="phone-foot-list spaceBetween" @click="goActivityDetail">
            <div class="phone-list-left start">
              <div class="phone-left-tips">SBTi</div>
              <div class="phone-left-radiu border1 columnCenter">
                <div class="phone-radiu-tips color1">11月</div>
                <div class="phone-radiu-center color1">20日</div>
              </div>
              <div class="phone-left-right">
                <div class="phone-right-title">活动名称活动活动名称活动活动名称活动活动名称活动名称活动活动名称</div>
                <div class="phone-right-bottom start">
                  <div class="phone-bottom-list start">
                    <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">线上会议</div>
                  </div>
                  <div class="phone-bottom-list start" style="margin-right:0;">
                    <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                    <div class="phone-list-font">20：00 —— 21：00</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <footerBar ref="footerView"></footerBar>

    <div class="index-layer" v-if="isShowLayer" @click="removeLayer">
      <div class="index-layer-center" @click.stop="">
        <div class="layer-center-all">
          <div class="layer-center-title middle"><span>请选择操作</span></div>
          <div class="layer-center-list middle" v-for="(item,index) in titleList" :key="index" @click="goChanceList(item)">{{lanType==1?item.title:item.titleEn}}</div>
        </div>
        <div class="layer-center-remove middle" @click.stop="removeLayer">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import tab from '@/components/tab';
import footerBar from '@/components/footerBar';
import axios from 'axios';
import { chunkArr,format } from '@/utils/util';
import 'video.js/dist/video-js.css';
import indexBg from '@/images/indexBg.jpg';
import config from '@/utils/config';
export default {
  name: 'Home',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      videoPlay:'start',
      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: '' //url地址
        }],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      videosIndex:0,
      videos:'',
      indexBg:indexBg,
      indexBanner:{},
      indexVideos:[],
      projectList:[],
      pageProjectList:{},
      newsList:[],
      campaignList:[],
      projectBlock:{},
      isShowWeb:config.urlList.isShowWeb,
      lanType:1,
      isShowLayer:false,
      titleList:[]
    }
  },
  methods:{
    showLayerBtn(res){
      const vm=this
      
       if(res.id==4){
        vm.goChance(res)
      }else{
        vm.titleList = res.titleList
        vm.isShowLayer=true
      }
    },
    removeLayer(){
      const vm=this
      vm.isShowLayer=false
    },
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    goChance(item){
      const vm=this
      if(item.id==3){
        vm.$router.push({ path:'/climatesolver'})
        return
      }else if(item.id==4){
        vm.$router.push({ path:'/fuel'})
        return
      } if(item.id==1){
        vm.$router.push({ path:'/sbti'})
      }else if(item.id==2){
        vm.$router.push({ path:'/RE'})
      }else{
        vm.$router.push({path:'/projectDetail',query:{id:item.id}})
      }
      // if(item.id==1||item.id==2){
      //   vm.$router.push({ path:'/chance',query:{id:item.id}  })
      // }else if(item.id==3){
      //   window.open('http://climatesolver.wwfchina.org/')
      // }else{
      //   vm.$router.push({ path:'/joinCBH'})
      // }
    },
    goChanceList(item){
      const vm=this
      vm.$router.push({ path:'/projectDetail',query:{id:item.id}  })
    },
    playVideo(index){
      const vm=this;
      vm.videoPlay='play';
      if(index<0){
        vm.playerOptions.autoplay=true;
      }
      let str=`pcVideo${index}`
      $('.pcVideo').trigger('pause')
      $(`#${str}`).trigger('play')
    },
    onPlayerEnded(player){
      const vm=this;
      vm.videoPlay='end';
    },
    toReplay(){
      const vm=this;
      vm.videoPlay='play';
    },
    choiceVideo(index){
      const vm=this;
      vm.videosIndex=index;
      vm.videoPlay='play';
      vm.playerOptions.sources[0].src=vm.indexVideos[index].contentStr;
      
      vm.playerOptions.poster=vm.indexVideos[index].picStr;
      vm.indexBg=vm.indexVideos[index].picStr
      vm.playerOptions.autoplay=true;
    },
    queryBanner(){
      const vm=this;
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/carousel`,
      {
        type:1
      }
      ).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.sub_titleEn = da.sub_titleEn?da.sub_titleEn:da.sub_title
            da.pic_urlStr=`${config.urlList.imgUrl}${da.pic_url}`
          })
          vm.indexBanner=res.data.data
        }
      })
    },
    goPage(item){
      const vm=this
      window.open(item.url,'_blank')
    },
    queryvideos(){
      const vm=this;
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/videos`,
      {
        is_recommend:1,
        per_page:9
      }).then(res => {
        if(res.data.code==1){

          res.data.data.data.forEach(da=>{
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.contentStr=`${config.urlList.imgUrl}${da.content}`
            da.picStr=`${config.urlList.imgUrl}${da.pic}`
          })
          if(res.data.data.data.length>0){
            vm.playerOptions.sources[0].src=res.data.data.data[0].contentStr
            vm.indexBg=res.data.data.data[0].picStr
          }
          vm.indexVideos=res.data.data.data
        }
      })
    },
    goVideos(){
      const vm=this
      vm.$router.push({ path:'/videoList'})
    },
    setTitle(da){
      const vm=this
      if(da.titleEn){
        return da
      }
      switch (da.title) {
        case '科学碳目标':
          da.titleEn = "Science Based Target initiative (SBTi)";
          break;
        case '科学碳目标简介':
          da.titleEn = "Introduction";
          break;
        case '设置科学碳目标':
          da.titleEn = "Setting SBTi";
          break;
        case '案例':
          da.titleEn = "Best practice";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '绿色电力需求行动':
          da.titleEn = "China Corporate Renewable Energy Program";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.titleEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.titleEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.titleEn = "Corporate RE Pilot Project";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '气候创行者':
          da.titleEn = "Climate Solver";
          break;
        case '气候创行者简介':
          da.titleEn = "Introduction";
          break;
        case '加入CBH':
          da.titleEn = "JoinUs";
          break;
        default: 
          da.titleEn = da.title;
      }
      return da
    },
    queryProjectList(index){
      const vm=this
      let arr=vm.projectList
      
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          if(index==0){
            res.data.data.forEach(da=>{
              
              da=vm.setTitle(da)
              da.picStr=`${config.urlList.imgUrl}${da.pic}`;
              da.titleList=[];
              vm.queryProjectList(da.id)
            })
            vm.projectList=res.data.data;
          }else{
            vm.projectList.forEach(da=>{
              res.data.data.forEach(res=>{
                res=vm.setTitle(res)
                if(da.id==4){
                  da.hover=true;
                }
                if(da.id==res.parent_id){
                  
                  da.titleList.push(res);
                }
              })
            })
            vm.pageProjectList={
              pcData:chunkArr(vm.projectList,4),
              data:chunkArr(vm.projectList,2),
            }
          }
        }
      })
    },
    queryNewsList(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/news_list`,{
        type:1,
        project_id:0,
        per_page:4,
        is_recommend:1
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
            da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.briefEn = da.briefEn?da.briefEn:da.brief
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.updated_at=format(new Date(da.updated_at),'YYYY-MM-DD')
          })
          vm.newsList=res.data.data.data
        }
      })
    },
    queryCampaignList(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/campaign_list`,{
        state:1,
        is_recommend:1,
        per_page:9,
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.addressEn = da.addressEn?da.addressEn:da.address
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.addressStr=format(new Date(da.start_date),' YYYY年');
            da.addressStrEn=format(new Date(da.start_date),' YYYY/');
            da.startTimeMoth=format(new Date(da.start_date),' MM月')
            da.startTimeMothEn=format(new Date(da.start_date),' MM/')
            da.startTimeDay=format(new Date(da.start_date),' DD日')
            da.startTimeDayEn=format(new Date(da.start_date),' DD')
          })
          vm.campaignList=res.data.data.data
        }
      })
    },
    goMechanism(item){
      const vm=this
      vm.$router.push({ path:'/mechanism',query:{id:item.id,type:1}})
    },
    goActivityDetail(item){
      const vm=this
      vm.$router.push({ path:'/activityDetail',query:{id:item.id}})
    },
    queryBlock(){
      const vm=this
      ///api/cbh/block
      axios.get(
      `${config.urlList.queryUrl}/api/cbh/block/1`,
      ).then(res => {
        if(res.data.code==1&&res.data.data){
          res.data.data.titleEn = 'Introduction'
          res.data.data.contentEn = 'To help companies enhance their climate ambitions and accelerate corporate climate actions, WWF China and its strategic partner One Planet Foundation (OPF) of Shenzhen developed Climate Business Hub China (CBH China). It provides streamlined, integrated, and localized support for companies in target setting, renewable energy procurement, and low-carbon innovation. CBH China offers the following programs for companies and their suppliers to address their climate footprint.<br/>CBH China includes the following programs: Science Based Target initiative (SBTi), China Corporate RE Program and Climate Solver. '
          
          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
          vm.projectBlock=res.data.data
        }
      })
    },
    goNewsList(){
      const vm=this
      vm.$router.push({ path:'/news'  })
    },
    goActivity(){
      const vm=this
      vm.$router.push({ path:'/activity'  })
    },
  },
  created () {
    
  },
  mounted(){
    const vm=this
    vm.queryBanner();
    vm.queryvideos();
    vm.queryProjectList(0);
    vm.queryNewsList();
    vm.queryCampaignList();
    vm.queryBlock();
    setTimeout(()=>{
      var startX,endX;
      var offset = 50;
      $(".carousel").on('touchstart',function (e) {
        startX = e.originalEvent.touches[0].clientX;
      }).on('touchmove',function (e) {
        endX = e.originalEvent.touches[0].clientX;
      }).on('touchend',function (e) {
        var distance = Math.abs(startX - endX);
        if (distance > offset){
          $(this).carousel(startX >endX ? 'next':'prev');
        }
      })

      $('#carousel-example-generic5').on('slide.bs.carousel', function (obj) {
        vm.videosIndex = $(this).find('.item').index(obj.relatedTarget);
        vm.videoPlay=vm.videoPlay=='start'?'start':'end';
        $('.pcVideo').trigger('pause')
      })
    },1200)
  }
}
</script>
<style scoped>
.container-fluid{
  margin: 0;
  padding: 0;
}
/**  轮播图公用样式  **/
.carousel-banner,.carousel-new-phone{
  position: relative;
}
.carousel-indicators li{
  margin: 0 5px !important;
  background: #fff!important;
  width: 10px!important;
  height: 10px!important;
}
.carousel-indicators .active{
  width: 24px!important;
  background: #49bc9b!important;
  border: none!important;
  height: 10px!important;
}

/**  pc 提示条样式  **/
.web-index-neck{
  font-size: 0.26rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
  font-family:'wwf';
}
/* .web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #49bc9b;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
} */

/**  web 提示条样式  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  line-height: 2;
  position: relative;
  font-family:'wwf';
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #49bc9b;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}


/**  pc banner  **/
.index-top-web{
  width: 80%;
  height: auto;
  position: relative;
  margin:0 auto;
}
.inner-item-img{
  width: 100%;
  /* height: 5.7rem !important; */
}
.inner-item-center{
  padding: 0.225rem 0.25rem;
  background: rgba(0,0,0,0.5);
  border-radius: 4px;
  position: absolute;
  left: 0.5rem;
  top: 0.9375rem;
}
.item-center-title{
  font-size: 0.225rem;
  color: #fff;
  line-height: 1.2;
  font-family: 'wwf';
  width: 2.625rem;
  text-align: left;

}
.item-center-tips{
  width: 2.625rem;
  text-align: left;
  font-size: 0.1125rem;
  color: #fff;
  margin-top: 0.225rem;
}
.item-center-btn{
  width: 1.125rem;
  height: 0.3125rem;
  text-align: center;
  line-height: 0.3125rem;
  background: #49bc9b;
  font-size: 0.15rem;
  color: #ffffff;
  margin-top: 0.1875rem;
  cursor: pointer;
}

/**  web banner  **/
.index-top-phone{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 8rem !important;
}
.phone-inner-center{
  padding: 0.48rem 0.53rem;
  background: rgba(0,0,0,0.5);
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.phone-center-title{
  font-size: .66rem;
  color: #fff;
  font-family: 'wwf';
  width: 7.8rem;
  text-align: left;
}
.phone-center-tips{
  margin-top: 0.45rem;
  font-size: 0.32rem;
  color: #fff;
  text-align: left;
}
.phone-center-btn{
  width: 2.667rem;
  height: .8rem;
  background: #49bc9b;
  margin-top: .5rem;
  font-size: .32rem;
  color: #fff;
  font-weight: 500;
  text-align: center;
  line-height: 0.8rem;
}

/**  pc项目介绍  **/

.index-neck-tips{
  color: #000;
  font-size: 0.1125rem;
  margin-top: 0.5rem;
  padding: 0 1rem;
  align-items: flex-start;
}
.neck-tips-img{
  width: 1.875rem;
  height: auto;
  margin-right: 0.5675rem;
}
.neck-tips-font{
  margin-top: 0.125rem;
  text-align: left;
}
.tips-font-title{
  font-size: 0.35rem;
  color: #000;
  text-align: left;
  font-family: 'wwf';
  line-height: 1;
  margin-bottom: 10px;
}
.index-neck-web{
  margin-top: 0.2875rem;
}
.index-neck-item{
  width: 90%;
  height: auto;
  margin:0 auto;
}
.neck-item-list{
  flex: 2;
  cursor: pointer;
  height: auto;
}
.item-list-li{
  /* padding: 0.1rem 0.6625rem; */
  height: auto;
  background: rgba(96,55,155,0.3);
  border-radius: 6px;
  font-size: 0.1675rem;
  font-weight: 500;
  position: relative;
  font-family: 'wwf';
  width: 24%;
  height: 0.46rem;
  text-align: center;
  line-height: 0.46rem;
}
.list-li-center{
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  padding: 10px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: none;
}
.list-li-center::before{
  content: "";
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  left: 50%;
  top: -10px;
  transform: translateX(-50%);
}
.item-list-li:hover .list-li-center{
  display: block;
}
.list-li-bg1{
  background: rgba(116,185,160,0.3);
  color: rgba(116,185,160,1);
}
.list-li-bg2{
  background: rgba(248,173,59,0.3);
  color: rgba(248,173,59,1);
}
.list-li-bg3{
  background: rgba(60,139,192,0.3);
  color: rgba(60,139,192,1);
}
.hiddenHover{
  flex: 2;
  cursor: pointer;
  height: auto;
  min-height: 2.7rem;
  justify-content: flex-start;
}
.item-list-img{
  width: 1.275rem;
  height: 1.275rem;
}
.index-neck-indicators{
  bottom: -0.4rem;
}
.item-list-font{
  font-size: 0.26rem;
  line-height: 1.4;
  margin-top: 0.325rem;
  font-family: 'wwf';
}
.item-list-btns{
  display: none;
}
.neck-item-list:hover .item-list-img{
  width: 0.25rem;
  height: 0.25rem;
}
.neck-item-list:hover .item-list-font{
  font-size: 0.24rem;
  margin-top: 0.1rem;
  font-family: 'wwf';
}
.neck-item-list:hover .item-list-btns{
  display: block;
}
.neck-item-list:hover{
  height: auto;
}
.list-btns-btn{
  width: 100%;
  height: 0.26rem;
  text-align: center;
  line-height: 0.26rem;
  font-size: 0.12rem;
  font-family: 'wwf';
  border-bottom: 1px solid #ddd;
}
.list-btns-btn:last-child{
  border-bottom: none;
}
.neck-btn-left{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  left: 0.3rem;
  transform: translateY(-50%);
  color: #000;
}
.neck-btn-right{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  right: 0.3rem;
  transform: translateY(-50%);
  color: #000;
}

/**  web 项目介绍  **/
.phone-neck{
  padding: 0 0.5rem 1rem;
}
.phone-neck-img{
  width: 80%;
  height: auto;
  margin: 0.5rem 0;
}
.phone-neck-tips{
  font-size: 0.32rem;
  color: #000;
  text-align: left;
  margin-top: 0.46rem;
}
.phone-neck-indicators{
  bottom: -1.2rem;
}
.phone-neck-item{
  width: 100%;
  height: auto;
}
.carousel-inner-list{
  width: 100%;
  height: auto;
}
.inner-list-li{
  width: 100%;
  max-width: 100%;
  padding: 0.3rem 0.21rem;
  height: auto;
  margin-bottom: 0.32rem;
  background: rgba(96,55,155,0.3);
  border-radius: 4px;
  font-size: 0.35rem;
  color: rgb(96,55,155);
  font-weight: 600;
  font-family: 'wwf';
}
.inner-li-bg1{
  background: rgba(116,185,160,0.3);
  color: rgba(116,185,160,1);
}
.inner-li-bg2{
  background: rgba(248,173,59,0.3);
  color: rgba(248,173,59,1);
}
.inner-li-bg3{
  background: rgba(60,139,192,0.3);
  color: rgba(60,139,192,1);
}
.phone-item-list{
  flex: 2;
  height: auto;
  min-height: 9.4rem;
  justify-content: flex-start;
}
.phone-item-img{
  width: 2.4rem;
  height: 2.4rem;
}
.phone-item-font{
  font-size: 0.46rem;
  font-family: 'wwf';
  margin-top: 0.32rem;
}
.phone-btns-btn{
  width: 3.6rem;
  height: 0.9rem;
  font-size: 0.32rem;
  margin-top: 0.3rem;
  text-align: center;
  line-height: 0.9rem;
  font-family: 'wwf';
}

/**  pc视频播放  **/
.web-belly-center{
  width: 100%;
  height: auto;
  margin-top: 0.425rem;
  position: relative;
}
.belly-center-img{
  width: 100%;
  height: auto;
}
.belly-center-img /deep/ .vjs-poster{
  background-size: cover;
}
.belly-center-img /deep/ .vjs-big-play-button{
  width: 2em !important;
  border-radius: 50% !important;
  border-width: 1px;
}
.belly-center-imgBtn{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 0.4rem;
  height: 0.4rem;
}
.web-belly-content{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5.125rem;
  z-index: 9;
}
.belly-top-font{
  margin-top: 0.5rem;
  border-bottom: 1px solid #fff;
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  cursor: pointer;
}
.belly-top-img{
  width: 0.2625rem;
  height: 0.2625rem;
  margin-right: 0.125rem;
  display: inline-block;
  vertical-align: text-bottom;
}
.belly-top-tips{
  font-size: 0.3rem;
  color: #fff;
  display: inline-block;
  font-family:'wwf';
}
.belly-content-center{
  padding: 0 0.5rem;
  margin-top: 0.575rem;
}
.content-center-list{
  width: 2.8125rem;
  height: auto;
}
.center-list-video{
  width: 2.8125rem;
  height: 1.4375rem;
  border: 4px solid #fff;
}
.center-list-font{
  font-size: 0.15rem;
  color: #fff;
  font-weight: 600;
  margin-top: 0.2125rem;
  font-family:'wwf';
}
.list-video-real{
  width: auto;
  height: 1.36rem;
}
.web-belly-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #49bc9b;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 500;
  margin: 0.625rem auto 0;
  cursor: pointer;
  font-family:'wwf';

}

/**  web视频播放  **/
.phone-belly-center{
  margin-top: 0.667rem;
  width: 100%;
  height: 5.12rem;
  position: relative;
}
.phone-belly-img{
  width: 100%;
  height: 5.12rem;
}
.swiper-slide{
  position: relative;
  height: 100%;
}
.phone-belly-imgBtn{
  width: 1rem;
}

/**  pc 新闻动态  **/
.web-index-leg{
  padding: 0.3375rem 0.5rem 0;
  height: auto;
}
.index-leg-left{
  width: 4.3875rem;
  height: auto;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-left-top{
  width: 100%;
  height: auto;
  position: relative;
}
.leg-left-img{
  width: 100%;
  height: 2.5rem;
}
.left-top-bottom{
  position: absolute;
  bottom: 0;
  left: 0.1875rem;
  right: 0.1875rem;
  height: auto;
}
.top-bottom-list{
  padding: 0.075rem;
  font-size: 0.1rem;
  color: #ffffff;
  background: #32a5cf;
  line-height: 1;
  margin-bottom: 0.1875rem;
  margin-right: 0.1875rem;
  display: block;
  float: left;
}
.left-top-bottom::after{
  content: '';
  display: block;
  clear: both;
}
.leg-left-center{
  padding: 0.1875rem;
  height: auto;
  background: #fff;
}
.left-center-title{
  font-size: 0.225rem;
  color: #000;
  font-family: 'wwf';
  text-align: left;
  line-height: 1.4;
  height: 0.63rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.left-center-tips{
  font-size: 0.1125rem;
  color: #000;
  margin-top: 0.1rem;
  text-align: left;
  line-height: 1.4;
  height: 0.63rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
.left-center-bottom{
  margin-top: 0.1875rem;
  cursor: pointer;
}
.center-bottom-left{
  font-size: 0.1125rem;
  color: #999999;
  text-align: left;
}
.index-leg-right{
  margin-left: 0.225rem;
  flex: 2;
  height: 4.534rem;
}
.leg-right-list{
  width: 100%;
  height: 1.25rem;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.right-list-left{
  width: 1.875rem;
  min-width: 1.875rem;
  height: 1.25rem;
  position: relative;
}
.list-left-img{
  width: 100%;
  height: 100%;
}
.list-left-bottom{
  position: absolute;
  left: 0.0625rem;
  bottom: 0;
  right: 0.0625rem;
}
.list-left-bottom::after{
  content: "";
  display: block;
  clear: both;
}
.list-left-list{
  padding: 0.0625rem 0.075rem;
  font-size: 0.09375rem;
  color: #fff;
  background: #32a5cf;
  margin-bottom: 0.125rem;
  margin-right: 4px;
  float: left;
  line-height: 1;
}
.right-list-right{
  padding: 0.15rem;
  height: 1.25rem;
  width: 100%;
}
.list-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  height: 0.525rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}
.right-list-bottom{
  width: 100%;
  cursor: pointer;
}

/**  web 新闻动态  **/
.phone-index-leg{
  margin-top: 0.74rem;
  padding: 0 0.5rem;
}
.phone-leg-top{
  width: 100%;
  height: auto;
  margin-bottom: 0.48rem;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-top-images{
  width: 100%;
  height: 5.334rem;
  position: relative;
}
.top-images-img{
  width: 100%;
  height: 100%;
}
.top-images-list{
  position: absolute;
  bottom: 0;
  left: 0.5rem;
  right: 0.5rem;
}
.top-images-list::after{
  content: "";
  display: block;
  clear: both;
}
.images-list-li{
  padding: 0.2rem 0.26rem;
  line-height: 1;
  color: #fff;
  font-size: 0.32rem;
  background: #436aba;
  margin-bottom: 0.25rem;
  margin-left: 0.25rem;
  display: block;
  float: left;

}
.leg-top-bottom{
  padding: 0.56rem 0.48rem;
  background: #fff;
}
.top-bottom-title{
  font-size: 0.48rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-bottom: 0.32rem;
  text-align: left;
}
.top-bottom-tips{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.4;
  text-align: left;
}
.bottom-bottom-left{
  font-size: 0.32rem;
  color: #999;
  text-align: left;
}
.top-bottom-bottom{
  margin-top: 0.4rem;
  cursor: pointer;
}
.phone-leg-list{
  margin-bottom: 0.48rem;
  height: auto;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-list-left{
  width: 4rem;
  height: 2.667rem;
  position: relative;
}
.list-left-img{
  width: 100%;
  height: 100%;
}
.phone-list-bottom{
  position: absolute;
  left: 0.32rem;
  bottom: 0;
  right: 0.32rem;
}
.phone-list-bottom::after{
  content: "";
  display: block;
  clear: both;
}
.leg-list-right{
  padding: 0.3rem;
  height: 2.667rem;
  flex: 2;
}
.phone-list-title{
  font-size: 0.4rem;
  line-height: 1.4;
  height: 1.12rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}
.top-bottom-bottom{
  width: 100%;
}

/**  pc活动预告  **/
.web-index-foot{
  padding: 0.3375rem 0.5rem 0;
  height: auto;
}
.index-foot-tips{
  margin-bottom: 0.1875rem;
  font-size: 0.225rem;
  color: #999999;
  text-align: left;
  font-weight: 'wwf';
}
.index-foot-list{
  width: 100%;
  height: 0.75rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.225rem;
  cursor: pointer;
}
.foot-list-left{
  width: auto;
  height: 0.75rem;
}
.list-left-tips{
  width: 0.1875rem;
  height: 0.75rem;
  background: #32a5cf;
  font-size: 0.15rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
}
.list-left-radiu{
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-left: 0.125rem;
  border-width: 2px !important;
}
.left-radiu-tips{
  font-size: 0.15rem;
  color: #32a5cf;
  font-weight: 'wwf';
  line-height: 1.4;
}
.left-radiu-center{
  font-size: 0.225rem;
  color: #32a5cf;
  font-family: 'wwf';
  line-height: 1.4;
}
.list-left-right{
  margin-left: 0.2625rem;
  height: 0.75rem;
}
.left-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1;
  margin-top: 0.1625rem;
}
.left-right-bottom{
  margin-top: 0.1125rem;
}
.bottom-list-img{
  width: 0.1875rem;
  height: auto;
  margin-right: 0.0625rem;
}
.right-bottom-list{
  margin-right: 0.25rem;
}
.bottom-list-font{
  font-size: 0.1125rem;
  color: #000;
  line-height: 0.1875rem;
}
.foot-list-right{
  color: #49bc9b;
  font-size: 0.1125rem;
  margin-right: 0.175rem;
  cursor: pointer;
}

/**  web活动预告  **/
.phone-index-foot{
  padding: 0.373rem 0.5rem 0;
  height: auto;
}
.phone-foot-tips{
  margin-bottom: 0.48rem;
  font-size: 0.64rem;
  color: #999999;
  text-align: left;
  font-weight: 'wwf';
}
.phone-foot-list{
  width: 100%;
  height: 2.4rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.533rem;
}
.phone-list-left{
  width: auto;
  height: 2.4rem;
}
.phone-left-tips{
  width: 0.56rem;
  height: 2.4rem;
  background: #32a5cf;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
}
.phone-left-radiu{
  width: 1.333rem;
  min-width: 1.333rem;
  height: 1.333rem;
  border-radius: 50%;
  margin-left: 0.347rem;
  border-width: 2px !important;
}
.phone-radiu-tips{
  font-size: 0.32rem;
  color: #32a5cf;
  font-weight: 'wwf';
  line-height: 1.4;
}
.phone-radiu-center{
  font-size: 0.48rem;
  color: #32a5cf;
  font-family: 'wwf';
  line-height: 1.4;
}
.phone-left-right{
  margin-left: 0.373rem;
  height: 2.4rem;
}
.phone-right-title{
  font-size: 0.4rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-top: 0.2667rem;
  text-align: left;
}
.phone-right-bottom{
  margin-top: 0.32rem;
}
.phone-list-img{
  width: 0.426rem;
  height: auto;
  margin-right: 0.133rem;
}
.phone-bottom-list{
  margin-right: 0.8rem;
}
.phone-list-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 0.426rem;
}

.color1{
  color: #32a5cf;
}
.color2{
  color: #436aba;
}
.color3{
  color: #ed9534;
}
.color4{
  color: #49bc9b;
}
.border1{
  border:1px solid #32a5cf;
}
.border2{
  border:1px solid #436aba;
}
.border3{
  border:1px solid #ed9534;
}
.border4{
  border:1px solid #49bc9b;
}
.bg1{
  background: #436aba;
}
.bg2{
  background: #ed9534;
}

.index-layer{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.index-layer-center{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
.layer-center-all{
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 8px 8px 0 0;
}
.layer-center-title{
  padding: 0 0.3rem;
  height: 46px;
  border-bottom: 1px solid #ddd;
  font-size: 0.3rem;
  color: #000;
  font-weight: 600;
  border-radius: 8px 8px 0 0;
}
.layer-center-list{
  width: 100%;
  height: 1rem;
  border-bottom: 1px solid #ddd;
  font-size: 16px;
  color: #000;
  font-weight: 500;
}

.layer-center-remove{
  width: 100%;
  height: 52px;
  font-size: 0.3rem;
  color: #000;
  font-weight: 600;
  margin-top: 4px;
  background: #fff;
}
</style>

